import { AfterContentInit, Directive, ElementRef, inject, input, InjectionToken } from '@angular/core';

export const SURVEY_AUTO_FOCUS_SCROLL = new InjectionToken<boolean>('SURVEY_AUTO_FOCUS_SCROLL', { factory: (): boolean => true });

@Directive({
  selector: '[surveyAutoFocus]'
})
export class AutoFocusDirective implements AfterContentInit {
  condition = input<boolean>(true);
  block = input<'start' | 'center' | 'end' | 'nearest'>('start');
  animationDelay = input<number>(0);

  private readonly scrollEnabled = inject(SURVEY_AUTO_FOCUS_SCROLL);

  constructor(private elementRef: ElementRef) {}

  ngAfterContentInit(): void {
    if (this.condition()) {
      setTimeout(() => {
        const allFocusElements = document.querySelectorAll('[surveyAutoFocus]');
        const isFirst = allFocusElements.length === 0 || allFocusElements[0] === this.elementRef.nativeElement;
        if (isFirst) {
          this.elementRef.nativeElement.focus({ preventScroll: !this.scrollEnabled });
          if (this.scrollEnabled) {
            this.elementRef.nativeElement.scrollIntoView({ behavior: 'smooth', block: this.block() });
          }
        }
      }, this.animationDelay());
    }
  }
}
